import { Component, Input, OnInit } from '@angular/core';

import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-products-list-section-a',
  templateUrl: './products-list-section-a.component.html',
  styleUrls: ['./products-list-section-a.component.scss']
})
export class ProductsListSectionAComponent extends BaseComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  image: string;

  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  ngOnInit(): void {}
}
